import { render, staticRenderFns } from "./del_kszp.vue?vue&type=template&id=039e2436&scoped=true&"
import script from "./del_kszp.vue?vue&type=script&lang=js&"
export * from "./del_kszp.vue?vue&type=script&lang=js&"
import style0 from "./del_kszp.vue?vue&type=style&index=0&id=039e2436&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "039e2436",
  null
  
)

export default component.exports